<template>
  <div>
    <!-- ヘッダー部分 -->
    <div class="title">
      <!-- 左側: 戻るボタン -->
      <div class="left" v-if="showBackButton">
        <button class="back-button" @click="$router.go(-1)">
          <img src="/img/back_icon.png" alt="back" />
        </button>
      </div>

      <!-- 中央: 会社名 & ユーザーアイコン -->
      <div class="center">
        <span class="company-name">{{ packItem.corporation_name }}</span>
        <img class="user-icon" :src="packItem.corporation_image" alt="user" />
      </div>

      <!-- 右側: 販売者のガチャ一覧ボタン -->
      <div class="right">
        <button class="seller-button" @click="goToCorporationDetail">
          {{t('この販売者のガチャ一覧')}}
          <img class="arrow-icon" src="/img/menu_right.png" alt="arrow" />
        </button>
      </div>
    </div>

    <!-- ラインナップとバナー画像 -->
    <div class="down">
      <span class="jpn">{{ jpn }}</span>
      <div class="right-banner" v-if="packItem">
        <img class="product-banner" :src="packItem.image" />
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'TitleStore',
  mixins: [t],

  props: {
    jpn: {
      type: String,
      default: '',
    },
    showBackButton: {
      type: Boolean,
      default: false, // デフォルトは非表示
    },
    packItem: {
      type: Object,
      default: () => ({}), // `null` の場合はデフォルトのオブジェクトを返す
    },
  },
  methods: {
    goToCorporationDetail() {
      this.$router.push(`/store/page/${this.packItem.corporation_url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $gray2;
  .left {
    .back-button {
      background: none;
      border: none;
      padding: 0;
      img {
        width: 40px;
      }
    }
  }
  .center {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    font-weight: bold;
    .user-icon {
      border-radius: 50%;
      width: 45px;
      height: 45px;
      margin-left: 10px;
    }
  }
  .right {
    .seller-button {
      display: flex;
      align-items: center;
      background: white;
      border: 2px solid #f0f0f0;
      border-radius: 20px;
      font-size: 16px;
      padding: 4px 6px;
      cursor: pointer;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
      .arrow-icon {
        width: 25px;
        margin-left: 5px;
      }
    }
  }
}
// ↓下側
.down {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 5px;
  .jpn {
    font-size: 24px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
  }
  .right-banner {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 10px;
    width: auto;
    max-width: 150px; // 親が押し広げられないよう制限
    img{
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
      height: auto;
      max-width: 150px; // 親が押し広げられないよう制限
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .title {
    padding: 8px;
    font-size: 16px;
    .left .back-button img {
      width: 30px;
    }
    .center{
      font-size: 18px;
    }
    .right .seller-button {
      font-size: 12px;
      padding: 4px 8px;
      .arrow-icon {
        width: 12px;
      }
    }
  }

  .down {
    padding: 10px;
    .jpn {
      font-size: 20px;
    }
    .right-banner img {
      width: 150px;
    }
  }
}

@media screen and (max-width: $mobileWidth) {
  .title {
    align-items: center;
    .center {
      font-size: 18px;
      .user-icon {
        height: 30px;
        width: 30px;
      }
    }
    .seller-button {
      font-size: 9px;
      padding: 3px 6px;
      .arrow-icon {
        width: 22px;
      }
    }
  }

  .down {
    align-items: center;
    .jpn {
      font-size: 18px;
    }
    .right-banner img {
      width: 120px;
    }
  }
}
</style>
